import rolesConstants from "@/components/acl/roles";

export default [
  {
    title: 'Management',
    icon: 'far fa-analytics',
    collapsed: false,
    permissions: [
      'companies_dashboard'
    ],
    children: [
      {
        title: 'Training Status',
        name: 'dashboard@training-status',
        icon: 'far fa-user-chart',
        permissions: [
          'companies_dashboard'
        ],
        isRoute: true
      },
      {
        title: 'Event / Document Status',
        name: 'dashboard@event-status',
        icon: 'far fa-user-chart',
        permissions: [
          'companies_dashboard'
        ],
        isRoute: true
      },
      // {
      //   title: 'Company Profile',
      //   name: 'companies@show',
      //   icon: 'far fa-building',
      //   permissions: [
      //     'companies_show'
      //   ],
      //   isRoute: true
      // },
      {
        title: 'Groups',
        name: 'companies_groups@index',
        icon: 'far fa-users',
        permissions: [
          'companies_groups_index'
        ],
        isRoute: true
      },
      {
        title: 'People',
        name: 'companies_users@active',
        icon: 'far fa-users-class',
        permissions: [
          'companies_users_index'
        ],
        isRoute: true
      },
      {
        title: 'Historical',
        name: 'companies_users@historical',
        icon: 'far fa-rectangle-history-circle-user',
        roles: [
          rolesConstants.ROLE_COMPANY_MANAGER,
          rolesConstants.ROLE_TRAINING_MANAGER
        ],
        // permissions: [
        //   'companies_users_index'
        // ],
        isRoute: true
      }
    ]
  },
  {
    title: 'Settings',
    name: 'system@settings',
    icon: 'far fa-cog',
    collapsed: false,
    roles: [rolesConstants.ROLE_ADMIN],
    children: [
      {
        title: 'Permissions',
        name: 'system@settings',
        icon: 'far fa-user-tag',
        roles: [rolesConstants.ROLE_ADMIN],
      }
    ]
  },
  {
    title: 'My Training',
    icon: 'far fa-user-graduate',
    collapsed: false,
    roles: [rolesConstants.ROLE_TRAINEE],
    children: [
      {
        title: 'Train Now',
        icon: 'far fa-play',
        name: 'my@training',
        roles: [rolesConstants.ROLE_TRAINEE],
        highlight: true
      },
      {
        title: 'Program',
        icon: 'far fa-book-open',
        name: 'my@program',
        roles: [rolesConstants.ROLE_TRAINEE]
      },
      {
        title: 'Schedule',
        icon: 'far fa-calendar-alt',
        name: 'my@schedule',
        roles: [rolesConstants.ROLE_TRAINEE]
      },
      {
        title: 'Training Record',
        icon: 'far fa-file-chart-line',
        name: 'my@records',
        roles: [rolesConstants.ROLE_TRAINEE]
      },
      {
        title: 'Events / Documents',
        icon: 'far fa-folders',
        name: 'my_events@index',
        roles: [rolesConstants.ROLE_TRAINEE]
      }
    ]
  },
];
